// removed by extract-text-webpack-plugin
module.exports = {"content":"ReasonsView__content___2z_9E"};